module.exports = __webpack_public_path__ + "static/t_27-e8bfe71cc63a50a6c35948ded8076b07.jpg";